import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GoalInformation } from 'src/app/enums/goal-information.enum';
import { LanguageService } from 'src/app/services/language.service';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-goal-information-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, SharedModule, TranslateModule],
  templateUrl: './goal-information-dialog.component.html',
  styleUrl: './goal-information-dialog.component.scss'
})
export class GoalInformationDialogComponent implements OnInit {

    public goalInfoType: GoalInformation;
    public contentUrl: string;

    constructor(
      @Inject(MAT_DIALOG_DATA) data: { goalInfoType: GoalInformation },
      private languageService: LanguageService,
      private translate: TranslateService
    ) {
      this.goalInfoType = data.goalInfoType;
    }

    ngOnInit(): void {
      const lang = this.languageService.getCurrentLanguage();
      this.contentUrl = this.getContentUrl(this.goalInfoType, lang);
    }

    private getContentUrl(goalInfoType: GoalInformation, lang: string): string {
      const fileName = this.getFileName(goalInfoType);
      return `/config/html/${lang}/${fileName}_${lang}.html`;
    }

    private getFileName(goalInfoType: GoalInformation): string {
      switch (goalInfoType) {
        case GoalInformation.Main:
          return 'goal-information-main';
        case GoalInformation.TextBasedGoal:
          return 'goal-information-text-based-goal';
        case GoalInformation.NumericGoals:
          return 'goal-information-numeric-goals';
        case GoalInformation.GroupGoals:
          return 'goal-information-group-goals';
        default:
          return 'goal-information-main';
      }
    }

    goalInfoTypes = GoalInformation;
}
